<template>
  <div class="regist">
    <div class="re_header">
      <ul>
        <li><i class="cls-or left-row"></i>填写账户信息<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>邮箱验证<i class="el-icon-arrow-right"></i></li>
        <li><i class="cls-or left-row"></i>设置新密码<i class="el-icon-arrow-right"></i></li>
        <li class="active"><i class="el-icon-circle-check left-row"></i>修改完成</li>
      </ul>
    </div>
    <hr>
    <div class="message">
      <h2>找回密码</h2>
      <div class="sc-sendsed">
        密码重置成功！
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'emali',
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less">
.regist {
  width: 1100px;
  margin: 10px auto;
  min-height: 650px;
  .re_header {
    overflow: hidden;
    line-height: 55px;
    height: 55px;
    margin: 35px 0px;
    background-color: #f5f7fa;
    ul {
      overflow: hidden;
      li {
        float: left;
        width: 195px;
        padding-left: 80px;
        color: #c1c5cd;
        .cls-or {
          display: inline-block;
          height: 12px;
          width: 12px;
          border-radius: 50%;
          box-shadow: 0 0 0 1px #c0c4cc;
        }
        .left-row {
          margin-right: 10px;
        }
        .el-icon-arrow-right {
          float: right;
          line-height: 55px;
        }
      }
      .active {
        color: rgb(28, 203, 150);
        font-weight: 600;
      }
    }
  }
  hr {
    background-color: #f5f7fa;
    height: 2px;
    border: 0;
    margin-bottom: 30px;
  }
  .message {
    border: 3px solid #f5f7fa;
    border-radius: 5px;
    color: #818180;
    text-align: left;
    h2 {
      padding-left: 25px;
      height: 45px;
      line-height: 45px;
      background-color: #f5f7fa;
    }
    .sc-sendsed {
      color: rgb(28, 203, 150);
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      padding: 35px 0;
      margin: 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/ResetSuccessPwd.vue